// Header.jsx
import React, { useState, useEffect } from 'react';
import { AppBar, Toolbar, Typography, Box, IconButton, Menu, MenuItem, Tooltip, Badge } from '@mui/material';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import MenuIcon from '@mui/icons-material/Menu'; // <- Use this for toggling
import image from "../../asserts/logo logistic.png";
import Swal from 'sweetalert2';
import { H6FormLabel } from '../../theme/Theme';
import { Profile } from '../Icons';
import ThemeColor from '../../theme/ThemeColor';
import { useNavigate } from 'react-router';
import ProfileModel from '../Custom/ProfileModel';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import { NotificationModal } from '../Custom';
import { getAllNotificationDetails } from '../../redux/Thunk/authThunk';
import { useDispatch } from 'react-redux';
import { deleteSingleNotification } from '../../redux/Thunk/authThunk'; 

const Header = ({ toggleSidebar }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [openProfile, setOpenProfile] = useState(false)  //Open the profile model
  const userDetails = JSON.parse(localStorage.getItem("userdetails"));
  const [openNotificationModal, setOpenNotificationModal] = useState(false)
  const [notifications, setNotifications] = useState([])

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  useEffect(() => {
    notificationDetails()
  }, [])

  const notificationDetails = () => {
    dispatch(getAllNotificationDetails(userDetails?.AdminName)).then((res) => {
      if (res?.payload?.success === true) {
        setNotifications(res?.payload?.data)
      }
    })
  }

  const handleOpenNotificationModal = () => {
    setOpenNotificationModal(true)
  }

  const handlecloseNotificationModal = () => {
    setOpenNotificationModal(false)
    notificationDetails()
  }

  // Add this function inside Header component:
 const handleSingleNotificationClose = (id) => {
  dispatch(deleteSingleNotification(id)).then((res) => {
    if (res?.payload?.success) {
      setNotifications((prev) => prev.filter((n) => n._id !== id));
    }
  });
};




  const unreadCount = notifications.filter(notification => !notification?.isRead)?.length;

  // Logout functionality 
  const handleLogout = () => {
    setAnchorEl(null)
    Swal.fire({
      title: "Are you sure want to logout ?",
      icon: "info",
      showCancelButton: true,
      cancelButtonText: "Cancel",
    }).then((res) => {
      if (res.isConfirmed) {
        localStorage.removeItem("accesstoken");
        localStorage.removeItem("refreshtoken");
        localStorage.removeItem("userdetails");
        navigate('/');
        window.location.reload();
      }
    });
  };

  return (
    <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, backgroundColor: '#CECECE' }}>
      <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
        {/* Left Side Logo + Menu Button */}
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <IconButton edge="start" onClick={toggleSidebar}>
            <MenuIcon sx={{ color: "#000" }} />
          </IconButton>
          <img src={image} width={50} height={50} alt="" style={{ objectFit: 'cover', marginLeft: '10px', marginRight: '30px' }} />
          <Typography variant="h6" noWrap sx={{ color: '#000' }}>
            LA Logistics Pvt. Ltd.
          </Typography>
        </Box>

        {/* Right Side */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {unreadCount > 0 ? <>
            <Tooltip title="Notification" placement="top-start" onClick={handleOpenNotificationModal}>
              <Badge badgeContent={unreadCount === 0 ? '' : unreadCount} color="success">
                <NotificationsNoneIcon sx={{ color: '#000' }} />
              </Badge>
            </Tooltip>
          </> :
            <Tooltip title="Notification" placement="top-start" onClick={handleOpenNotificationModal} >
              <NotificationsNoneIcon sx={{ color: '#000' }} />
            </Tooltip>
          }

          <IconButton onClick={handleMenuOpen} sx={{ gap: 1 }}>
            <AccountCircleIcon />
            <Typography sx={{ color: '#000', mr: 3 }}>{userDetails?.Role === 'Admin' ? 'Admin' : 'Office Admin'}</Typography>
          </IconButton>
          <Menu
            onClose={() => setAnchorEl(null)}
            open={open}
            sx={{ marginTop: '40px' }}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
            slotProps={{
              elevation: 1,
              sx: {
                overflow: 'visible',
                filter: 'drop-shadow(0px 4px 10px #efefef)',
                borderRadius: '0px 0px 8px 8px',
              },
            }}>
            <MenuItem sx={{ padding: '0 20px 10px 10px' }}>
              <Profile color={'#04AB44'} />
              <H6FormLabel onClick={() => { setOpenProfile(true); setAnchorEl(null) }} sx={{ fontSize: '16px', pl: 1.5, pt: 0, pb: 0, pr: 4, fontWeight: 500 }} >Profile</H6FormLabel>
            </MenuItem>
            <MenuItem onClick={handleLogout} sx={{ padding: '0 20px 10px 10px' }}>
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.2344 6.04688L15.1875 9L12.2344 11.9531" stroke="#04AB44" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M7.3125 9H15.1875" stroke="#04AB44" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M7.3125 15.1875H3.375C3.22582 15.1875 3.08274 15.1282 2.97725 15.0227C2.87176 14.9173 2.8125 14.7742 2.8125 14.625V3.375C2.8125 3.22582 2.87176 3.08274 2.97725 2.97725C3.08274 2.87176 3.22582 2.8125 3.375 2.8125H7.3125" stroke="#04AB44" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              <H6FormLabel sx={{ fontSize: '16px', pl: 1, pt: 0, pb: 0, pr: 5, fontWeight: 500 }}>Logout</H6FormLabel>
            </MenuItem>
          </Menu>
        </Box>
      </Toolbar>

      {/* ================ open Profile  =============== */}
      {openProfile && <ProfileModel setOpenProfile={setOpenProfile} openProfile={openProfile} />}

      {/*  Notification model open */}
      {openNotificationModal &&
        <NotificationModal
  notifications={notifications}
  open={openNotificationModal}
  setOpen={setOpenNotificationModal}
  onClose={handlecloseNotificationModal}
  setNotifications={setNotifications}
  handleSingleNotificationClose={handleSingleNotificationClose}
/>
}

    </AppBar>
  );
};

export default Header;
